import React from 'react';
import '../styles/Home.css'
import '../styles/App.css'
import SimpleAreaChart from '../components/graph';
import axios from 'axios'

class Home extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            history: [],
            searchTerm: ''
        };
    }

    componentDidMount() {
        axios.get("http://safetel.ddns.net:5000/history?user_id=PROTOTYPE_USER_1")
        .then((response) => {
            this.setState({
                isLoaded: true,
                history: response.data.history
            })
        })
        .catch((error) => {
            this.setState({
                isLoaded: true,
                error
            })
        })
    }

    render() {
        const { error, isLoaded} = this.state;
        if (error) {
            return (<div>Erreur : {error.message}</div>);
        } else if (!isLoaded) {
            return (<div>Chargement...</div>);
        } else {
            return (
                <div className='home'>
                    <SimpleAreaChart history={this.state.history} />
                </div>
            );
        }
    }
}

export default Home;